



































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import moment from "moment";
import Referensi from "@/services/Referensi";
import LaporanIndikatorRanap, {
  BorKelasBaris,
  DasarTt,
  IndikatorBaris,
  IndikatorFilter,
  IndikatorRanapResponse,
  JenisPeriode,
  KelasBor,
  KolomIndikator
} from "@/services/LaporanIndikatorRanap";
import { userModule } from "@/store/modules/user";

interface UnitOption {
  id: string;
  nama: string;
}

interface PilihanAngka {
  text: string;
  value: number;
}

const BULAN = [
  "Januari", "Februari", "Maret", "April", "Mei", "Juni",
  "Juli", "Agustus", "September", "Oktober", "November", "Desember"
];
const ROMAWI = ["I", "II", "III", "IV"];
const KELAS: Array<"vip" | "k1" | "k2" | "k3" | "iso" | "tk"> = ["vip", "k1", "k2", "k3", "iso", "tk"];
const INDIKATOR: KolomIndikator[] = ["bor", "los", "toi", "bto", "ndr", "gdr"];
const LABEL_KELAS_BOR: Record<KelasBor, string> = {
  vip: "VIP",
  k1: "I",
  k2: "II",
  k3: "III",
  tk: "TK",
  iso: "ISO"
};
const TAHUN_AWAL = 2024;

@Component
export default class LaporanIndikatorRanapPage extends Vue {
  readonly kemarin = moment().subtract(1, "day");

  jenis: JenisPeriode = "bulan";
  tahun = moment().startOf("month").subtract(1, "day").year();
  ke = moment().startOf("month").subtract(1, "day").month() + 1;
  dasarTt: DasarTt = "real";

  selectedUnits: string[] = [];
  unitOptions: UnitOption[] = [];
  loadingUnits = false;

  loading = false;
  printing = false;
  exporting = false;
  exportingTahunan = false;
  data: IndikatorRanapResponse | null = null;

  readonly jenisOptions = [
    { text: "Bulanan", value: "bulan" },
    { text: "Triwulan", value: "triwulan" },
    { text: "Semester", value: "semester" },
    { text: "Tahunan", value: "tahun" }
  ];

  get tahunOptions(): number[] {
    const out: number[] = [];
    for (let t = this.kemarin.year(); t >= TAHUN_AWAL; t--) out.push(t);
    return out;
  }

  get keOptions(): PilihanAngka[] {
    if (this.jenis === "bulan") {
      return BULAN.map((b, i) => ({ text: b, value: i + 1 }));
    }
    if (this.jenis === "triwulan") {
      return ROMAWI.map((r, i) => ({
        text: `Triwulan ${r} (${BULAN[i * 3]} – ${BULAN[i * 3 + 2]})`,
        value: i + 1
      }));
    }
    if (this.jenis === "semester") {
      return [
        { text: "Semester I (Januari – Juni)", value: 1 },
        { text: "Semester II (Juli – Desember)", value: 2 }
      ];
    }
    return [{ text: `Januari – Desember`, value: 1 }];
  }

  get labelKe(): string {
    if (this.jenis === "bulan") return "Bulan";
    if (this.jenis === "triwulan") return "Triwulan";
    if (this.jenis === "semester") return "Semester";
    return "Rentang";
  }

  get kemarinLabel(): string {
    return `${this.kemarin.date()} ${BULAN[this.kemarin.month()]} ${this.kemarin.year()}`;
  }

  get periodeTersedia(): boolean {
    const panjang = { bulan: 1, triwulan: 3, semester: 6, tahun: 12 }[this.jenis];
    const bulanAwal = (this.ke - 1) * panjang;
    const mulai = moment({ year: this.tahun, month: bulanAwal, date: 1 });
    return mulai.isSameOrBefore(this.kemarin, "day");
  }

  get tahunTersedia(): boolean {
    return moment({ year: this.tahun, month: 0, date: 1 }).isSameOrBefore(this.kemarin, "day");
  }

  get sibuk(): boolean {
    return this.loading || this.printing || this.exporting || this.exportingTahunan;
  }

  get filter(): IndikatorFilter {
    return {
      tahun: this.tahun,
      jenis: this.jenis,
      ke: this.jenis === "tahun" ? 1 : this.ke,
      dasar_tt: this.dasarTt,
      unit: this.selectedUnits
    };
  }

  get barisTabel(): IndikatorBaris[] {
    if (!this.data) return [];
    return [...this.data.rows, this.data.total];
  }

  get barisBorKelas(): BorKelasBaris[] {
    if (!this.data) return [];
    const bk = this.data.bor_kelas;
    return bk.total ? [...bk.rows, bk.total] : bk.rows.slice();
  }

  get kepalaBorKelas(): string[] {
    if (!this.data) return [];
    const label = this.data.bor_kelas.kolom.map(k => LABEL_KELAS_BOR[k]);
    return [...label, "∑", ...label, ...label, ...label];
  }

  get perluMasterTt(): boolean {
    return !!this.data && this.data.catatan.tanpa_tt.length > 0;
  }

  get canKelolaTt(): boolean {
    return userModule.isSuperAdmin;
  }

  @Watch("jenis")
  onJenisChange() {
    const maks = this.keOptions.length;
    if (this.ke > maks) this.ke = maks;
    if (this.jenis === "tahun") this.ke = 1;
  }

  mounted() {
    this.loadUnits();
  }

  angka(v: number | null): string {
    if (v === null || v === undefined) return "–";
    return v.toLocaleString("id-ID");
  }

  desimal(r: IndikatorBaris, k: KolomIndikator): string {
    if (r.tersembunyi.includes(k)) return "";
    const v = r[k];
    if (v === null || v === undefined) return "–";
    return v.toLocaleString("id-ID", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  nilaiBaris(r: IndikatorBaris): string[] {
    const m = r.masuk as NonNullable<IndikatorBaris["masuk"]>;
    const p = r.pindahan as NonNullable<IndikatorBaris["pindahan"]>;
    const d = r.dirawat as NonNullable<IndikatorBaris["dirawat"]>;
    const kh = r.keluar_hidup as NonNullable<IndikatorBaris["keluar_hidup"]>;
    const dp = r.dipindah as NonNullable<IndikatorBaris["dipindah"]>;
    const mt = r.mati as NonNullable<IndikatorBaris["mati"]>;
    const kl = r.keluar as NonNullable<IndikatorBaris["keluar"]>;
    const hk = r.hp_kelas as NonNullable<IndikatorBaris["hp_kelas"]>;
    return [
      this.angka(r.hari),
      this.angka(r.awal),
      this.angka(m.L), this.angka(m.P),
      this.angka(p.L), this.angka(p.P),
      this.angka(r.jumlah_pasien),
      this.angka(d.L), this.angka(d.P), this.angka(d.jumlah),
      this.angka(kh.L), this.angka(kh.P),
      this.angka(dp.L), this.angka(dp.P),
      this.angka(mt.lt48), this.angka(mt.ge48), this.angka(mt.jumlah),
      this.angka(kl.hidup), this.angka(kl.mati), this.angka(kl.jumlah),
      this.angka(r.tt),
      this.angka(r.akhir),
      ...KELAS.map(k => this.angka(hk[k])),
      this.angka(r.hp),
      this.angka(r.ld),
      ...INDIKATOR.map(k => this.desimal(r, k)),
      this.angka(r.tt_x_hari_kurang_hp)
    ];
  }

  nilaiBorKelas(r: BorKelasBaris): string[] {
    const kolom = this.data ? this.data.bor_kelas.kolom : [];
    return [
      this.angka(r.hari),
      ...kolom.map(k => this.angka(r.tt[k])),
      this.angka(r.tt.jumlah),
      ...kolom.map(k => this.angka(r.hp[k])),
      ...kolom.map(k => this.persen(r.bor[k])),
      ...kolom.map(k => this.angka(r.tt_x_hari[k]))
    ];
  }

  persen(v: number | null): string {
    if (v === null || v === undefined) return "–";
    return v.toLocaleString("id-ID", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  kelasBaris(r: IndikatorBaris): string {
    if (r.jenis === "jumlah") return "jml";
    if (r.jenis === "total") return "total";
    return "";
  }

  goMenu() {
    this.$router.push({ name: "laporan-rp1-menu" }).catch(() => undefined);
  }

  goToMasterTt() {
    this.$router.push({ name: "superadmin-settings" }).catch(() => undefined);
  }

  async loadUnits() {
    this.loadingUnits = true;
    try {
      const data = await Referensi.getUnitPelayanan();
      this.unitOptions = (data ?? [])
        .map((u: { id: string | number; nama: string }) => ({
          id: String(u.id),
          nama: u.nama
        }))
        .filter((u: UnitOption) => u.id >= "50" && u.id < "80")
        .sort((a: UnitOption, b: UnitOption) => a.id.localeCompare(b.id));
    } catch {
      this.unitOptions = [];
    } finally {
      this.loadingUnits = false;
    }
  }

  async tampilkan() {
    this.loading = true;
    try {
      this.data = await LaporanIndikatorRanap.preview(this.filter);
    } catch {
      this.data = null;
    } finally {
      this.loading = false;
    }
  }

  async cetakPdf() {
    this.printing = true;
    await LaporanIndikatorRanap.openPdf(this.filter).catch(() => undefined);
    this.printing = false;
  }

  async unduhExcel() {
    this.exporting = true;
    await LaporanIndikatorRanap.downloadExcel(this.filter).catch(() => undefined);
    this.exporting = false;
  }

  async unduhExcelTahunan() {
    this.exportingTahunan = true;
    await LaporanIndikatorRanap.downloadExcelTahunan(this.tahun, this.selectedUnits).catch(
      () => undefined
    );
    this.exportingTahunan = false;
  }
}
